<div class="report-page-root-container  daily-sales-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg> -->
      <img class="icon" src="assets/images/menu/svg/daily-sales-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details" style="overflow: hidden;">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <!-- <div class="input-box-right"> -->
              <mat-form-field>
                <mat-label>Date From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.invalid && (editForm.get('period_from')?.touched || editForm.get('period_from')?.dirty)">
                  <ng-container *ngIf="editForm.get('period_from')?.hasError('required')">
                    Please select a date
                  </ng-container>

                </mat-error>
              </mat-form-field>

              <!-- </div> -->
              <!-- </div>
            <div class="input-group"> -->
              <div class="row">
                <mat-form-field>
                  <mat-label>Date To</mat-label>
                  <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                    [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY">
                  <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                  <mat-datepicker #pickerTo></mat-datepicker>
                  <mat-error
                    *ngIf="editForm.get('period_to')?.invalid && (editForm.get('period_to')?.touched || editForm.get('period_to')?.dirty)">
                    <ng-container *ngIf="editForm.get('period_to')?.hasError('required')">
                      Please select a date.
                    </ng-container>

                  </mat-error>
                </mat-form-field>

              </div>
            </div>
            <div class="row">
              <mat-form-field>
                <mat-label>Shop</mat-label>
                <input type="text" matInput formControlName="shop_id" [matAutocomplete]="autoShop"
                  (input)="filterShops()">
                <mat-autocomplete #autoShop="matAutocomplete" [displayWith]="displayShop"
                  (optionSelected)="onShopSelectionChange()">
                  <mat-option value="ALL">All</mat-option>
                  <mat-option *ngFor="let shop of filteredShopList" [value]="shop">
                    {{ shop.name }}
                  </mat-option>
                </mat-autocomplete>
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearShop()"
                  *ngIf="editForm.get('shop_id')?.value">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="editForm.get('shop_id')?.hasError('invalidShop') && editForm.get('shop_id')?.touched">
                  Please select a valid shop.
                </mat-error>
              </mat-form-field>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>